import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "./styles.css";
import MaterialTable from "@material-table/core";

import Header from "../../../Components/Header";
import LeftMenu from "../../../Components/LeftMenu";
import AddEditSpoke from "./AddEditSpoke.js";
import BulkUploadVillage from "./BulkUploadSpoke";

import {
  findallspokes,
  searchSpokesWithFilter,
} from "../../../Utils/Services/spokeMaster";
import SpokeFilter from "./SpokeFilter";
import MigrateSpoke from "./MigrateSpoke";
toast.configure();

const columns = [
  {
    title: "Spoke Id",
    field: "id",
  },
  { title: "Spoke Name", field: "spokeName" },
  { title: "Branch Name", field: "branchName" },
  { title: "Pincode", field: "pincode" },
  { title: "Tehsil", field: "tehsil" },
  { title: "District", field: "district" },
  { title: "State", field: "state" },
  { title: "Date Of Establishment", field: "dateOfEstablishment" },
  {
    title: "Status",
    field: "status",
    render: (rowData) => {
      return rowData && rowData.status === true ? "ACTIVE" : "INACTIVE";
    },
  },
];

const SpokeMaster = (props) => {
  let [SpokeData, setSpokeData] = useState([]);
  let [productDropdownOptions, setproductDropdownOptions] = useState([]);
  let [showAddProductNormModal, setshowAddProductNormModal] = useState(false);
  let [showEditNormModal, setshowEditNormModal] = useState(false);
  let [editData, setEditData] = useState({});
  let [showBulUploadModal, setshowBulUploadModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showMigrateSpokeModal, setshowMigrateSpokeModal] = useState(false);
  const [reloadAfterSpokeChange, setReloadAfterSpokeChange] = useState(true);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const isFilteringRef = useRef(false);
  const toastShownRef = useRef(false);
  const spokeFilterRef = useRef(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isITADMIN = userInfo?.role === "ITADMIN" || props?.role === "ITADMIN";
  const columns = [
    {
      title: "Spoke Id",
      field: "id",
    },
    { title: "Spoke Name", field: "spokeName" },
    { title: "Branch Name", field: "branchName" },
    { title: "Pincode", field: "pincode" },
    { title: "Tehsil", field: "tehsil" },
    { title: "District", field: "district" },
    { title: "State", field: "state" },
    { title: "Date Of Establishment", field: "dateOfEstablishment" },
    { title: "Business Type", field: "businessType" },

    {
      title: "Status",
      field: "status",
      render: (row) => {
        return row && row.status === true ? "ACTIVE" : "INACTIVE";
      },
    },
  ];

  useEffect(() => {
    spokeMaster(page);
    window.scrollTo(0, 0);
  }, []);

  const spokeMaster = (page) => {
    if (page === undefined || page === null) {
      page = 0;
    }
    findallspokes(page).then((response) => {
      if (response.error) {
        return;
      }
      if (response.data && response.data.error) {
        // Don't show error toast during initial load to avoid conflicts
        console.log("Initial load error:", response.data.message);
      } else {
        setSpokeData(response.data.content);
        setTotalPages(response.data.totalPages);
      }
    });
  };

  // Function to refresh table with initial data
  const refreshTableWithInitialData = () => {
    console.log("Refreshing table with initial data...");
    setIsFiltered(false);
    setFilterParams(null);
    setPage(0);
    spokeMaster(0);
    setTableKey(prev => prev + 1);
  };

  const getData = (query) => {
    return new Promise((resolve, reject) => {
      let page = query.page;
      
      if (isFiltered && SpokeData.length > 0) {
        // Use stored filtered data for pagination
        console.log("getData - Using stored filtered data:", SpokeData.length, "items"); // Debug log
        const pageSize = 10;
        const startIndex = page * pageSize;
        const endIndex = startIndex + pageSize;
        const paginatedData = SpokeData.slice(startIndex, endIndex);
        
        console.log("getData - Paginated data:", paginatedData.length, "items for page", page); // Debug log
        
        resolve({
          data: [...paginatedData],
          page: page,
          totalCount: SpokeData.length,
        });
      } else if (isFiltered && filterParams) {
        // If filtered but no data yet, call the API
        searchSpokesWithFilter(filterParams)
          .then((result) => {
            console.log("getData - Filter API Response:", result); // Debug log
            const actualResult = result.data;
            
            if (actualResult && actualResult.status === "success" && actualResult.result) {
              const allData = actualResult.result;
              const pageSize = 10;
              const startIndex = page * pageSize;
              const endIndex = startIndex + pageSize;
              const paginatedData = allData.slice(startIndex, endIndex);
              
              resolve({
                data: [...paginatedData],
                page: page,
                totalCount: allData.length,
              });
            } else if (actualResult && actualResult.data) {
              // Fallback for different response structure
              const allData = actualResult.data;
              const pageSize = 10;
              const startIndex = page * pageSize;
              const endIndex = startIndex + pageSize;
              const paginatedData = allData.slice(startIndex, endIndex);
              
              resolve({
                data: [...paginatedData],
                page: page,
                totalCount: allData.length,
              });
            } else {
              console.error("getData - Unexpected response structure:", actualResult);
              resolve({
                data: [],
                page: 0,
                totalCount: 0,
              });
            }
          })
          .catch((err) => {
            console.error("getData - Filter error:", err);
            reject({
              data: [],
              page: 0,
              totalCount: 0,
            });
          });
      } else {
        // Use regular pagination for unfiltered data
        findallspokes(page)
          .then((result) => {
            resolve({
              data: [...result.data.content],
              page: result.data.pageable.pageNumber,
              totalCount: result.data.totalElements,
            });
          })
          .catch((err) => {
            reject({
              data: [],
              page: 0,
              totalCount: 0,
            });
          });
      }
    });
  };

  const handleFilter = async (filterData) => {
    console.log("handleFilter called with:", filterData);
    if (loading || isFilteringRef.current) {
      console.log("Filter: Already loading or filtering, skipping");
      return;
    }
    isFilteringRef.current = true;
    setLoading(true);
    setFilterParams(filterData);
    setIsFiltered(true);
    
    try {
      const response = await searchSpokesWithFilter(filterData);
      
      console.log("Filter API Response:", response); // Debug log
      const actualResponse = response.data;
      
      if (response.error) {
        console.log("Filter: HTTP error -", response.message);
        // Error toast already shown by HTTP interceptor
        // Clear filter fields and reload initial data when error occurs
        if (spokeFilterRef.current) {
          spokeFilterRef.current.clear();
        }
        return;
      } else if (actualResponse && actualResponse.status === "success" && actualResponse.result) {
        // Store the search results for pagination
        console.log("Setting filtered data:", actualResponse.result); // Debug log
        setSpokeData(actualResponse.result);
        setTotalPages(Math.ceil(actualResponse.resultCount / 10)); // Calculate total pages
        setTableKey(prev => prev + 1); // Force table re-render
        toast.success(`Found ${actualResponse.resultCount} spokes`, {
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
        });
      } else if (actualResponse && actualResponse.data) {
        // Fallback for different response structure
        console.log("Setting filtered data (fallback):", actualResponse.data); // Debug log
        setSpokeData(actualResponse.data);
        setTotalPages(Math.ceil(actualResponse.data.length / 10));
        setTableKey(prev => prev + 1); // Force table re-render
        toast.success(`Found ${actualResponse.data.length} spokes`, {
          type: toast.TYPE.SUCCESS,
          autoClose: 3000,
        });
      } else {
        console.error("Unexpected response structure:", actualResponse);
        // Error toast already shown by HTTP interceptor
        // Clear filter fields and reload initial data when error occurs
        if (spokeFilterRef.current) {
          spokeFilterRef.current.clear();
        }
      }
    } catch (error) {
      console.error("Filter error:", error);
      // Error toast already shown by HTTP interceptor
      // Clear filter fields and reload initial data when error occurs
      if (spokeFilterRef.current) {
        spokeFilterRef.current.clear();
      }
    } finally {
      setLoading(false);
      isFilteringRef.current = false;
    }
  };


  const handleClearFilter = async () => {
    setLoading(true);
    
    // Reset all filter states
    setIsFiltered(false);
    setFilterParams(null);
    setPage(0);
    setSpokeData([]); // Clear filtered data
    
    try {
      // Call the pagination API to reload all data
      const response = await findallspokes(0);
      console.log("Clear - Reload API Response:", response); // Debug log
      
      if (response.error) {
        // Don't show error toast during clear to avoid conflicts
        console.log("Clear reload error:", "Error reloading data");
      } else if (response.data && response.data.error) {
        // Don't show error toast during clear to avoid conflicts
        console.log("Clear reload error:", response.data.message);
      } else {
        // Set the data directly for immediate UI update
        setSpokeData(response.data.content);
        setTotalPages(response.data.totalPages);
        
        // Force a re-render by updating the page state and table key
        setPage(0);
        setTableKey(prev => prev + 1);
      }
    } catch (error) {
      console.error("Clear - Reload error:", error);
      // Don't show error toast during clear to avoid conflicts
    } finally {
      setLoading(false);
    }
  };

  const handleAddSpoke = (id) => {
    setshowAddProductNormModal(!showAddProductNormModal);
  };

  const handleEditSpokeMaster = (obj) => {
    setshowEditNormModal(!showEditNormModal);
    setEditData(obj);
  };

  const handleBulkUpload = () => {
    setshowBulUploadModal(!showBulUploadModal);
  };

  const onPageChange = (index) => {
    setPage(index);
    if (isFiltered) {
      // For filtered results, we don't need pagination as they're not paginated
      return;
    } else {
      spokeMaster(index);
    }
  };

  return (
    <div className="dash_grid">
      <ToastContainer />
      <LeftMenu />
      <main className="bg-white">
        <Header {...props} />
        <section className="container-fluid mb-5">
          <h5 className="text-center mt-5 mx-auto user-box">
            Geographical Spoke Master
          </h5>

          <SpokeFilter 
            ref={spokeFilterRef}
            onFilter={handleFilter}
            onClear={handleClearFilter}
            loading={loading}
          />

          <div className="d-flex align-items-center mt-3">
            {isITADMIN && (
              <>
                <button
                  disabled={false}
                  onClick={handleAddSpoke}
                  className="add-btn ml-auto btn btn-info btn-lg"
                >
                  {" "}
                  Add{" "}
                </button>
                <button
                  disabled={false}
                  onClick={handleBulkUpload}
                  className="bulk-upload-button btn btn-info btn-lg"
                >
                  Bulk Upload Spoke
                </button>
                <button
                  className="bulk-upload-button btn btn-info btn-lg"
                  onClick={() =>
                    setshowMigrateSpokeModal(!showMigrateSpokeModal)
                  }
                >
                  Migrate Spoke
                </button>
              </>
            )}
            {showAddProductNormModal && (
              <AddEditSpoke
                action={"add"}
                SpokeMaster={getData}
                handleAddSpoke={handleAddSpoke}
                productDropdownOptions={productDropdownOptions}
              />
            )}
            {showEditNormModal && (
              <AddEditSpoke
                action={"edit"}
                SpokeMaster={getData}
                editData={editData}
                handleEditSpokeMaster={handleEditSpokeMaster}
                productDropdownOptions={productDropdownOptions}
              />
            )}
            {showMigrateSpokeModal && (
              <MigrateSpoke
                showMigrateSpokeModal={showMigrateSpokeModal}
                setshowMigrateSpokeModal={setshowMigrateSpokeModal}
                spokeMaster={spokeMaster}
              />
            )}
            {showBulUploadModal && (
              <BulkUploadVillage handleBulkUpload={handleBulkUpload} />
            )}
          </div>

          <div className={`mt-4 react-table hide-react-table-footer`} style={{ position: 'relative' }}>
            {loading && (
              <div className="text-center py-4" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000, backgroundColor: 'rgba(255, 255, 255, 0.9)', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            <MaterialTable
              key={`table-${tableKey}`}
              title=""
              columns={columns}
              data={getData}
              isLoading={loading}
              options={{
                search: false, // Disable search since we're using filter
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [10],
                idSynonym: "id",
                paging: true, // Enable pagination for both filtered and unfiltered results
                showTitle: false, // Hide the toolbar completely
                toolbar: false, // Hide the toolbar completely
                headerStyle: {
                  fontWeight: "bold",
                  textAlign: "center",
                  backgroundColor: "#17a2b8",
                  color: "#FFF",
                  padding: "15px",
                },
                tableLayout: "fixed",
              }}
              onRowClick={(event, row) => handleEditSpokeMaster(row)}
            />
          </div>
        </section>
      </main>
    </div>
  );
};

export default SpokeMaster;
